export default "__VITE_ASSET__Cq2e8C$C__"